import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NLocalOffers } from '../interfaces/services/local-offers.interfaces'
import { sortStringsAlphabetically } from '../helpers/sorting'

export const getLocalOffersPerSocieties = (
  societyId: string
): Promise<AxiosResponse<NLocalOffers.NGetPerSocieties.IResponse>> => {
  const body: NLocalOffers.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NLocalOffers.NGetPerSocieties.IResponse>(
    createUrl('/local-offers/get-per-societies'),
    body
  )
}

export const getLocalOffer = (
  id: string
): Promise<AxiosResponse<NLocalOffers.NGetById.IResponse>> => {
  return axiosAuth.get<NLocalOffers.NGetById.IResponse>(
    createUrl(`/local-offers/local-offer/${id}`)
  )
}

export const patchLocalOffer = (params: {
  id: string
  body: NLocalOffers.NPatch.IRequestBody
}): Promise<AxiosResponse<NLocalOffers.NPatch.IResponse>> => {
  return axiosAuth.patch<NLocalOffers.NPatch.IResponse>(
    createUrl(`/local-offers/local-offer/${params.id}`),
    params.body
  )
}

export const createLocalOffer = (
  body: NLocalOffers.NCreate.IRequestBody
): Promise<AxiosResponse<NLocalOffers.NCreate.IResponse>> => {
  return axiosAuth.post<NLocalOffers.NCreate.IResponse>(
    createUrl(`/local-offers/local-offer`),
    body
  )
}

export const deleteLocalOffer = (
  id: string
): Promise<AxiosResponse<NLocalOffers.NDel.IResponse>> => {
  return axiosAuth.delete<NLocalOffers.NDel.IResponse>(
    createUrl(`/local-offers/local-offer/${id}`)
  )
}

export const localOfferQueries = {
  getLocalOffer: (localOfferId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'localOffer', entity: 'detail', localOfferId }],
      queryFn: async ({ queryKey }) => {
        return (await getLocalOffer(queryKey[0].localOfferId!)).data.data
      },
      enabled: !!localOfferId,
    }),
  getLocalOffersPerSocieties: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'localOffer', entity: 'detail', societyId }],
      queryFn: async ({ queryKey }) => {
        const localOffers = (
          await getLocalOffersPerSocieties(queryKey[0].societyId!)
        ).data.data

        localOffers?.sort((a, b) =>
          sortStringsAlphabetically(a.companyName, b.companyName)
        )
        return localOffers
      },
      enabled: !!societyId,
    }),
}
